import { api } from '@/global/services/api'

const state = {
  items: [],
  pagination: {
    count: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 1,
    total: 0
  },
  subjectReport: null,
  sort: {},
  permissions: []
}

const getters = {
  list: state => state.items,
  pagination: state => state.pagination,
  sort: state => state.sort
}

const actions = {
  async fetch ({ commit, state }, options) {
    try {
      const params = {
        pagination: options.pagination,
        sort: options.sort,
        user: options.user,
        selectedModel: options.selectedModel,
        from: options.from,
        to: options.to
      }
      const {
        data,
        pagination,
        sort
      } = await api('base').get('user-activity', params)

      commit('SET_ITEMS', data)
      commit('SET_PAGINATION', pagination)
      commit('SET_SORT', sort)
    }
    catch (e) {
      console.dir(e)
    }
  }
}

const mutations = {
  SET_ITEMS: (state, payload) => (state.items = payload),
  SET_PAGINATION ({ pagination }, payload) {
    const { count, currentPage, perPage, totalPages, total } = payload
    pagination.count = count || 0
    pagination.currentPage = currentPage || 1
    pagination.perPage = perPage || 0
    pagination.totalPages = totalPages || 1
    pagination.total = total || 0
  },
  SET_SORT: (state, payload) => (state.sort = payload),
  SET_PERMISSIONS: (state, payload) => (state.permissions = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
